import "whatwg-fetch";
import Query from "url-query-parser";

const api = () => {
  const xhrPromise = (uri, req) => {
    return fetch(uri, req)
      .then(res => res.json())
      .then(json => json)
      .catch(err => new Error(err));
  };

  return {
    get: endpoint => {
      const head = {
        method: "GET"
        // headers: {
        //   "Content-type": "application/json"
        // }
      };
      return xhrPromise(endpoint, head);
    },
    post: (endpoint, body) => {
      const head = {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        },
        body: Query.stringify(body)
      };
      // if (body) {
      //   head.body = body;
      // }
      return xhrPromise(endpoint, head);
    }
  };
};

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js